export const periscopeDashboard = ({ token, client, agencies }) => ({
  HTTPMethod: "get",
  path: "/periscope_dashboard",
  queryParams: {
    client,
    agencies,
  },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
